import { t } from "@/i18n-js/instance";
import { BillingToggle } from "@/react/components/shared/BillingToggle";
import { annualDiscountPercentage } from "@/react/helpers/planHelpers";
import { useBillingCycleState } from "@/react/hooks/useBillingCycleState";
import { usePlans } from "../../../RegularPlan/PlansContext";
import { useAuxiliaryPlans } from "../../../hooks/useAuxiliaryPlans";

export const BillingCycleSwitch = () => {
  const { isYearly, shouldShowBillingCycleOptions, handleToggle } =
    useBillingCycleState();

  const { selectedPlan } = usePlans();

  const { yearlyPlan } = useAuxiliaryPlans();

  if (!selectedPlan || !yearlyPlan) {
    return null;
  }

  if (!shouldShowBillingCycleOptions) {
    return null;
  }

  return (
    <BillingToggle
      isAnnualPlan={isYearly}
      onChange={handleToggle}
      customText={t("pricing_plans.plan_settings.plan_summary.save_annually", {
        percentage: annualDiscountPercentage(yearlyPlan),
      })}
    />
  );
};
